import React, { useEffect } from 'react'
import { Button } from 'vnetwork-ui'
import { useForm } from 'react-hook-form'
import { DayOffLeaderApprove } from '@/modules/Dayoffs/types/payload'
import { approveLeadDayOff } from '@/modules/Dayoffs/services'
import toast from 'react-hot-toast'
import { IPermissionProps } from '@/types/shared'
import { DayOffResponse } from '@/modules/Dayoffs/types/response'
// import useAuthStore from '@/stores/useAuthStore'
import { FormItem } from 'vnetwork-ui'
import { yupResolver } from '@hookform/resolvers/yup'
import { leaderApproveSchema } from './yup'
import { useRefetchDayOffQueries } from '@/modules/Dayoffs/constants'
import { useTranslation } from 'react-i18next'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface DayOffFormLeaderProps extends IPermissionProps {
    dayOff: DayOffResponse
    onClose?: () => void
    refetch: () => void
}
const LeaderFormConfirm: React.FC<DayOffFormLeaderProps> = ({
    dayOff,
    refetch,
    onClose,
    scopes: _scopes,
}) => {
    const { t } = useTranslation('dayoffs')
    // const { employee } = useAuthStore()
    const { refetchAll } = useRefetchDayOffQueries()
    const { mutateAsync: LeaderConfirm, isPending: isLeaderConfirming } =
        useMutationWithHandler(
            {
                mutationFn: approveLeadDayOff,
            },
            {
                reactQueryKeys: QUERY_KEYS.DAYOFFS,
                errorMessage: t('something_went_wrong'),
            }
        )

    const {
        control: controlLeaderForm,
        handleSubmit: handleLeaderConfirm,
        setValue: setLeadFormValue,
    } = useForm<DayOffLeaderApprove>({
        defaultValues: {
            day_off_feedback_lead: t('approved'),
        },
        resolver: yupResolver(leaderApproveSchema),
    })

    const onLeaderSubmit = async (dataReq: DayOffLeaderApprove) => {
        if (dataReq?.day_off_feedback_lead?.trim() === '') {
            toast.error(t('please_feedback'))
        }
        try {
            await LeaderConfirm({
                id: dayOff?.day_off_id || 0,
                feedback: {
                    day_off_feedback_lead: dataReq?.day_off_feedback_lead,
                },
            })
            if (onClose) {
                onClose()
            }
            refetch()
            refetchAll()
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (dayOff?.day_off_leader_confirmed) {
            setLeadFormValue(
                'day_off_feedback_lead',
                dayOff?.day_off_feedback_lead
            )
        }
    }, [dayOff])

    return (
        <div className="w-full mb-2 bg-white rounded-lg p-4 text-sm mt-2">
            <form onSubmit={handleLeaderConfirm(onLeaderSubmit)}>
                <FormItem
                    control={controlLeaderForm}
                    name="day_off_feedback_lead"
                    type="textarea"
                    disabled={dayOff?.day_off_status !== 'pending'}
                    placeholder={t('leader_feedback')}
                    label={t('leader_feedback')}
                />
                <div className="w-full flex justify-end gap-2">
                    {onClose && (
                        <Button
                            size="small"
                            type="button"
                            onClick={onClose}
                            variant="outlined"
                        >
                            {t('close')}
                        </Button>
                    )}
                    <Button
                        loading={isLeaderConfirming}
                        type="submit"
                        size="small"
                        className="min-w-[120px]"
                        disabled={
                            dayOff?.day_off_status !== 'pending' ||
                            isLeaderConfirming
                        }
                    >
                        {t('confirm')}
                    </Button>
                </div>
            </form>
        </div>
    )
}

export const LeaderForm = (props: DayOffFormLeaderProps) => {
    return <LeaderFormConfirm {...props} />
}
